<template>
    <Background>
        <img
            class="logo"
            src="https://goldbox-static.oss-cn-shanghai.aliyuncs.com/staff/logo.svg">
        <div class="icon-area">
            <div
                v-on:click="merchantManage"
                class="icon-button">
                <img
                    class="icon"
                    src="https://goldbox-static.oss-cn-shanghai.aliyuncs.com/staff/add_merchant.svg"/>
                <div class="icon-text">商户管理</div>
            </div>
            <div
                v-on:click="commodityReview"
                class="icon-button">
                <img
                    class="icon"
                    src="https://goldbox-static.oss-cn-shanghai.aliyuncs.com/staff/commodity_review.svg"/>
                <div class="icon-text">商品审核</div>
            </div>
            <div
                v-on:click="orderTracking"
                class="icon-button">
                <img
                    class="icon"
                    src="https://goldbox-static.oss-cn-shanghai.aliyuncs.com/staff/order_tracking.svg"/>
                <div class="icon-text">订单查询</div>
            </div>
            <div
                v-on:click="userFeedback"
                class="icon-button">
                <img
                    class="icon"
                    src="https://goldbox-static.oss-cn-shanghai.aliyuncs.com/staff/user_feedback.svg"/>
                <div class="icon-text">意见反馈</div>
            </div>
            <div
                v-on:click="cupboardManage"
                class="icon-button">
                <img
                    class="icon"
                    src="https://goldbox-static.oss-cn-shanghai.aliyuncs.com/staff/cupboard_manage.svg"/>
                <div class="icon-text">货柜管理</div>
            </div>
            <!--<div
                v-on:click="reviewerManage"
                class="icon-button">
                <img
                    class="icon"
                    src="https://goldbox-static.oss-cn-shanghai.aliyuncs.com/staff/add_order_admin.svg"/>
                <div class="icon-text">识别系统管理</div>
            </div>-->
            <div
                v-on:click="testerManage"
                class="icon-button">
                <img
                    class="icon"
                    src="https://goldbox-static.oss-cn-shanghai.aliyuncs.com/staff/add_factory_tester.svg"/>
                <div class="icon-text">测试人员管理</div>
            </div>
            <!--<div
                v-on:click="stafferManage"
               class="icon-button">
                <img
                    class="icon"
                    src="https://goldbox-static.oss-cn-shanghai.aliyuncs.com/staff/staffer.svg"/>
                <div class="icon-text">后台人员管理</div>
            </div>-->
            <div
                v-on:click="deviceManage"
                class="icon-button">
                <img
                    class="icon"
                    src="https://goldbox-static.oss-cn-shanghai.aliyuncs.com/staff/device_manage.svg"/>
                <div class="icon-text">主控管理</div>
            </div>
            <div
                v-on:click="printBoxQrCode"
                class="icon-button">
                <img
                    class="icon"
                    src="https://goldbox-static.oss-cn-shanghai.aliyuncs.com/staff/device_manage.svg"/>
                <div class="icon-text">打印主控二维码</div>
            </div>
            <div
                v-on:click="lostVideo"
                class="icon-button">
                <img
                    class="icon"
                    src="https://goldbox-static.oss-cn-shanghai.aliyuncs.com/staff/order_tracking.svg"/>
                <div class="icon-text">丢视频订单监控</div>
            </div>
            <div
                v-on:click="doorCannotOpen"
                class="icon-button">
                <img
                    class="icon"
                    src="https://goldbox-static.oss-cn-shanghai.aliyuncs.com/staff/order_tracking.svg"/>
                <div class="icon-text">无法开门订单监控</div>
            </div>
            <div
                v-on:click="longVideo"
                class="icon-button">
                <img
                    class="icon"
                    src="https://goldbox-static.oss-cn-shanghai.aliyuncs.com/staff/order_tracking.svg"/>
                <div class="icon-text">长视频订单监控</div>
            </div>
        </div>
    </Background>
</template>

<script>
 import Vue from 'vue';
 import Background from "./Background.vue"
 import Input from "ant-design-vue/lib/input";

 Vue.component(Input.name, Input);

 export default {
     name: 'Home',
     props: {
     },
     components: {
         Background
     },
     methods: {
         commodityReview() {
             this.$router.push("/commodityReview")
         },
         merchantManage() {
             this.$router.push("/merchantManage")
         },
         reviewerManage() {
             this.$router.push("/reviewerManage")
         },
         testerManage() {
             this.$router.push("/testerManage")
         },
         stafferManage() {
             this.$router.push("/stafferManage")
         },
         deviceManage() {
             this.$router.push("/deviceManage")
         },
         printBoxQrCode() {
             this.$router.push("/printBoxQrCode")
         },
         cupboardManage() {
             this.$router.push("/cupboardManage")
         },
         userFeedback() {
             this.$router.push("/userFeedback")
         },
         orderTracking() {
             this.$router.push("/orderTracking")
         },
         lostVideo() {
             this.$router.push("/lostVideo")
         },
         doorCannotOpen() {
             this.$router.push("/doorCannotOpen")
         },
         longVideo() {
             this.$router.push("/longVideo")
         },
     }
 }
</script>

<style scoped>
 .logo {
     width: 200px;
     margin-bottom: 60px;
 }

 .input {
     width: 400px;
     border-radius: 20px;
 }

 .input::placeholder {
     text-align: center
 }

 .icon-area {
     display: grid;
     grid-template-columns: 120px 120px 120px 120px 120px;
     justify-content: center;

     margin-top: 40px;
 }

 .icon-button {
     display: flex;
     flex-direction: column;
     align-items: center;
     cursor: pointer;
 }

 .icon-button:hover {
     transform: scale(1.1);
 }

 .icon {
     width: 48px;
     margin-left: 40px;
     margin-right: 40px;
 }

 .icon-text {
     color: #666;
     font-size: 13px;
     margin-top: 10px;
     margin-bottom: 40px;
 }
</style>
